export class ChangePassword {
    userId: string;
    oldPassword: string;
    newPassword: string;
    confirmPassword: string;

}
